import { WinnerCard } from "./WinnerCard";

export const RacingWaitingScreenWinners = (clientData) => {
  const winners = clientData.winners.data;
  const hasWinners = Array.isArray(winners) && winners.length > 0;

  return (
    <>
      {hasWinners && (
        <section>
          <div className="waiting-screen__winners">
            <div className="winners">
              <div className="winners__heading background">
                <div className="background__angle-top-right" />
                <p>Previous winner{winners.length === 1 ? "" : "s"}</p>
              </div>
            </div>
            <ul>
              {winners.slice(0, 3).map((winner) => (
                <WinnerCard
                  key={winner.id || winner.name} // Assuming winner has an id or name
                  winnerToUser={winner}
                  clientData={clientData}
                  hasBanner={false}
                />
              ))}
            </ul>
          </div>
        </section>
      )}
    </>
  );
};
